import { ReactNode } from 'react';
import { Grid, Paper, Typography } from '@mui/material';

import { RichText } from 'components';
import { formatBoolean } from 'utils/string';

import { InfoBlockProps } from './types';

export const InfoBlock = ({ size, title, value }: InfoBlockProps) => {
  const renderValue = (value: ReactNode) => {
    if (value === null || value === undefined) {
      return (
        <Typography
          sx={{
            color: 'text.secondary',
          }}
        >
          N/A
        </Typography>
      );
    }
    if (typeof value === 'boolean') {
      return <Typography>{formatBoolean(value)}</Typography>;
    }
    if (typeof value === 'string') {
      return <RichText value={value} editable={false} />;
    }
    return value;
  };

  return (
    <Grid size={size ?? { sm: 6, xs: 12 }}>
      <Paper sx={{ px: 2, py: 1 }}>
        <Typography variant="overline">{title}</Typography>
        {renderValue(value)}
      </Paper>
    </Grid>
  );
};
